// Copyright 2019 The Casbin Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import { Logger } from './logger';

// DefaultLogger is the implementation for a Logger
export class DefaultLogger implements Logger {
  private enable = false;

  public enableLog(enable: boolean): void {
    this.enable = enable;
  }

  public isEnable(): boolean {
    return this.enable;
  }

  public print(...v: any[]): void {
    if (this.enable) {
      console.log(...v);
    }
  }

  public printf(format: string, ...v: any[]): void {
    if (this.enable) {
      console.log(format, ...v);
    }
  }
}
